import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FormattedMessage } from '../../i18n/FormattedMessage';
import '../TaskListLayout/TaskLayout.css';
import PropTypes from 'prop-types';
import { getDateFormat } from '../../utils/utils';
import DeficiencyIcon from '../../components/DeficiencyIcon';
import {
  hasDeficiency,
  getDeficiencyForIcon,
  deriveDeficiencyReportOptions,
} from '../../utils/deficiencyHelpers';

/**
 * Complete Report Layout Row component
 */
const CompleteReportLayoutRow = (props) => {
  const {
    row,
    setSelectedReportEditId,
    setClassVisibility,
    isClassVisible,
    country,
  } = props;
  const idToExpand = Object.keys(isClassVisible);
  const isIdToExpand = isClassVisible[idToExpand[0]];

  /**
   * Show the deficiency link icon only when the row has at least one viewable
   * linked report. Options are derived client-side from sibling rows in the
   * current list (grouped by deficiencyId); the PDF status poller keeps sibling
   * `reportPDFDetails` fresh, so an option appears as soon as its PDF is ready.
   */
  const linkedReports = deriveDeficiencyReportOptions(row, props.allRows);
  const shouldShowDeficiencyIcon =
    hasDeficiency(row.deficiencyId) && linkedReports.length > 0;

  /**
   * Get deficiency object for the icon
   */
  const deficiencyForIcon = getDeficiencyForIcon(row.deficiencyId);

  return (
    <tr
      className={
        row._id === idToExpand[0] && isIdToExpand
          ? 'accordion-opened test-class'
          : 'test-class'
      }
      style={
        row._id === idToExpand[0] && isIdToExpand
          ? { maxHeight: '1000px', cursor: 'pointer' }
          : { maxHeight: '60px', cursor: 'pointer' }
      }
      onClick={() => setSelectedReportEditId(row)}
    >
      <td id="">
        <h3>
          <FormattedMessage id="Customer Name" defaultMessage="Customer Name" />
        </h3>
        {row.createdForName}
      </td>

      <td id="">
        <h3>
          <FormattedMessage id="Category" defaultMessage="Category" />
        </h3>
        {row.reportCategory}
      </td>

      <td id="">
        <h3>
          <FormattedMessage id="Start Date" defaultMessage="Start Date" />
        </h3>
        {moment(row.createdAt).format(getDateFormat())}
      </td>
      <td id="">
        <h3>
          <FormattedMessage id="Modified Date" defaultMessage="Modified Date" />
        </h3>
        {moment(row.updatedAt).format(getDateFormat())}
      </td>
      <td id="">
        <h3>
          <FormattedMessage id="Actions" defaultMessage="Actions" />
        </h3>
        {shouldShowDeficiencyIcon && deficiencyForIcon && (
          <DeficiencyIcon
            deficiency={deficiencyForIcon}
            options={linkedReports}
            tooltipText="View linked reports"
          />
        )}
      </td>
      <span
        className="icon-accordion"
        onClick={() => setClassVisibility(row._id)}
      >
        {row._id === idToExpand[0] && isIdToExpand ? '-' : '+'}
      </span>
    </tr>
  );
};
CompleteReportLayoutRow.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
  reportHeading: PropTypes.string,
  setSelectedReportInfoId: PropTypes.func,
  setSelectedReportEditId: PropTypes.func,
  isClassVisible: PropTypes.object,
  setClassVisibility: PropTypes.func,
  country: PropTypes.string,
  allRows: PropTypes.array,
};

const mapStateToProps = ({ auth }) => ({
  country: auth.login.user.businessAddress.country.toLowerCase(),
});
export default connect(mapStateToProps)(CompleteReportLayoutRow);
